module.exports = __webpack_public_path__ + "static/media/reinaldo_gen_ichiro_arakaki.dc8cbdc8.jpg";